/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cal_3_DInputs */

const en_cp_cal_3_d = /** @type {(inputs: Cp_Cal_3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skeleton, then core value. Every task passes verification before done; the lecturer approves each phase.`)
};

const id_cp_cal_3_d = /** @type {(inputs: Cp_Cal_3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kerangka lalu nilai inti. Tiap task lulus verifikasi sebelum selesai; dosen setujui fase.`)
};

/**
* | output |
* | --- |
* | "Skeleton, then core value. Every task passes verification before done; the lecturer approves each phase." |
*
* @param {Cp_Cal_3_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cal_3_d = /** @type {((inputs?: Cp_Cal_3_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cal_3_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cal_3_d(inputs)
	return en_cp_cal_3_d(inputs)
});